import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
  LogoutIcon,
  HistoryIcon,
  UserCircleIcon,
  RightArrowIcon,
  CoinIcon,
  LockIcon,
  LanguageIcon,
} from "../../Components/Common/Icons";
import languagePack from "../../Utils/language";
import globalContext from "../../Hooks/globalContext";
import PageWrapper from "../../Components/Common/PageWrapper";
import { CLIENT_HOST, HOST } from "../../Utils/constants";
import Axios from "axios";
import useState from "../../Hooks/useState";
import Theme from "../../Styles/Theme";

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 5px;
  padding: 0px 20px;
  :not(:last-child) {
    margin-bottom: 5px;
  }

  :hover {
    opacity: 0.75;
  }
  cursor: pointer;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;

const Item = styled.div`
  display: flex;
  font-size: 14px;
  align-items: center;
`;

const ItemLabel = styled.span`
  color: black;
  margin-left: 10px;
`;

const MenuItem = ({ language, title, icon, onClick, code }) => {
  return (
    <Row onClick={onClick}>
      <Item>
        {icon}
        <ItemLabel>{title}</ItemLabel>
      </Item>
      <Item>
        {onClick && !code && <RightArrowIcon color={Theme.darkGrey} size={18} />}
        {code && <ItemLabel>{code}</ItemLabel>}
      </Item>
    </Row>
  );
};

const Page = ({ history }) => {
  const { httpHeader, language, user, logout, modal } = useContext(globalContext);
  const point = useState("");
  const otpStatus = useState(null);
  // const onCopy = () => {
  //   modal.setState(languagePack("추천인 코드가 복사되었습니다.", language.state));
  // };
  const getPoint = async () => {
    const { data } = await Axios.post(`${HOST}/user/point`, null, httpHeader());
    point.setState(data);
  };

  const initSetting = async () => {
    const { data } = await Axios.post(`${HOST}/user/otp/check`, null, httpHeader());
    otpStatus.setState(data.isNull === 1);
  };

  const otpOnPress = async () => {
    const { data } = await Axios.post(`${HOST}/user/otp/check`, null, httpHeader());
    otpStatus.setState(data.isNull === 1);

    if (data.isNull === 1) {
      // navigation.navigate("PinCodeRegisterOTP");
    } else {
      // navigation.navigate("PinCodeResetOTP");
    }
  };

  const historyOnClick = () => {
    history.push(`/market/history`);
  };

  useEffect(() => {
    otpOnPress();
    getPoint();
  }, []);

  return (
    <PageWrapper contentStyle={{ alignItems: "flex-start" }}>
      <Wrapper>
        {user.state && (
          <>
            <MenuItem
              icon={<UserCircleIcon color={"grey"} size={24} />}
              title={`${user.state.email}`}
              language={language}
            />
            {otpStatus.state ? (
              <MenuItem
                icon={<LockIcon color={"grey"} />}
                title={languagePack("OTP 등록", language.state)}
                onClick={() => history.push("/otp/register")}
                language={language}
              />
            ) : (
              <MenuItem
                icon={<LockIcon color={"grey"} />}
                title={languagePack("OTP 재설정", language.state)}
                onClick={() => history.push("/otp/reset")}
                language={language}
              />
            )}
            {/* <CopyToClipboard text={`${CLIENT_HOST}/register/${user.state.referral_code}`} onCopy={onCopy}>
              <MenuItem
                icon={<CodeIcon color={"grey"} size={24} />}
                title={languagePack("추천 코드", language.state)}
                code={user.state.referral_code}
                language={language}
              />
            </CopyToClipboard> */}
            <MenuItem
              icon={<CoinIcon color={"grey"} />}
              title={languagePack("포인트", language.state)}
              code={`${point.state} Point`}
              language={language}
            />
            <MenuItem
              icon={<HistoryIcon color={"grey"} />}
              title={languagePack("구매 기록", language.state)}
              language={language}
              onClick={historyOnClick}
            />
            <MenuItem
              icon={<LanguageIcon color={"grey"} />}
              title={languagePack("언어", language.state)}
              language={language}
              onClick={() => history.push("/config/language")}
            />
            <MenuItem
              icon={<LogoutIcon color={"grey"} />}
              title={languagePack("로그아웃", language.state)}
              language={language}
              onClick={logout}
            />
          </>
        )}
      </Wrapper>
    </PageWrapper>
  );
};
export default Page;
